import React, { useState, useEffect, useRef } from 'react';

// --- CONFIG ---
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// --- HELPERS ---
const apiCall = async (endpoint, method = 'GET', body = null) => {
    try {
      const options = {
          method,
          headers: body ? { 'Content-Type': 'application/json' } : {},
          body: body ? JSON.stringify(body) : null
      };
      const url = `${API_BASE_URL}${endpoint}`;
      const res = await fetch(url, options);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || data.error || "Terjadi kesalahan");
      return data; 
    } catch (err) {
      console.error("API Error:", err);
      throw err;
    }
};

// --- ICONS ---
const Icons = {
    Library: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-16,16V88H152V56ZM40,56H88V88H40ZM40,104H88v48H40Zm160,96H152V168h48v32Zm0-48H152V104h48v48Zm-64,48H104V168h48v32Zm0-48H104V104h48v48ZM88,200H40V168H88v32Z"/></svg>,
    Intel: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M224,176a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,176ZM104,80H40a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm120,40H40a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16Zm-8,48a8,8,0,0,0-8,8v40a8,8,0,0,0,16,0V176A8,8,0,0,0,216,168Zm-48,0a8,8,0,0,0-8,8v40a8,8,0,0,0,16,0V176A8,8,0,0,0,168,168ZM120,168a8,8,0,0,0-8,8v40a8,8,0,0,0,16,0V176A8,8,0,0,0,120,168ZM72,168a8,8,0,0,0-8,8v40a8,8,0,0,0,16,0V176A8,8,0,0,0,72,168ZM24,168a8,8,0,0,0-8,8v40a8,8,0,0,0,16,0V176A8,8,0,0,0,24,168Z"/></svg>,
    Creative: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-16,16V88H152V56ZM40,56H88V88H40ZM40,104H88v48H40Zm160,96H152V168h48v32Zm0-48H152V104h48v48Zm-64,48H104V168h48v32Zm0-48H104V104h48v48ZM88,200H40V168H88v32Z"/></svg>,
    Planner: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z"/></svg>,
    Performance: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z" opacity="0.2"/><path d="M232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Zm-61.66-45.66a8,8,0,0,0-11.32,0l-26.34,26.35-10.35-10.35a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,154.34,82.34Z"/></svg>,
    Repurpose: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-24,0a80,80,0,1,0-80,80A80.09,80.09,0,0,0,208,128Zm-85.66,29.66a8,8,0,0,1-11.32-11.32L132.69,128,111,106.34a8,8,0,0,1,11.32-11.32l28,28a8,8,0,0,1,0,11.32Z"/></svg>,
    GenTools: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM156,88a12,12,0,1,1-12,12A12,12,0,0,1,156,88Zm60,112H40V160.75l45.44-45.44a16,16,0,0,1,22.62,0L136,143.25l42.44-42.44a16,16,0,0,1,22.62,0l36,36Z"/></svg>,
    Video: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM156,88a12,12,0,1,1-12,12A12,12,0,0,1,156,88Zm60,112H40V160.75l45.44-45.44a16,16,0,0,1,22.62,0L136,143.25l42.44-42.44a16,16,0,0,1,22.62,0l36,36Z"/></svg>,
    Magic: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM156,88a12,12,0,1,1-12,12A12,12,0,0,1,156,88Zm60,112H40V160.75l45.44-45.44a16,16,0,0,1,22.62,0L136,143.25l42.44-42.44a16,16,0,0,1,22.62,0l36,36Z"/></svg>,
    Upload: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-32-80a8,8,0,0,1-8,8H136v24a8,8,0,0,1-16,0V144H96a8,8,0,0,1,0-16h24V104a8,8,0,0,1,16,0v24h24A8,8,0,0,1,168,136Z"/></svg>,
    Settings: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256"><path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"/></svg>
};

// --- SHARED UI COMPONENTS ---

// 1. Splash Screen
const SplashScreen = ({ onFinish }) => {
    const [opacity, setOpacity] = useState(1);
    const [show, setShow] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setOpacity(0);
            setTimeout(() => {
                setShow(false);
                onFinish();
            }, 800);
        }, 3000);
        return () => clearTimeout(timer);
    }, [onFinish]);

    if (!show) return null;

    return (
        <div 
            className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#050505] transition-opacity duration-800"
            style={{ opacity: opacity }}
        >
            <div className="flex flex-col items-center animate-fadeInUp">
                <div className="flex items-center gap-8 mb-10">
                    <div className="flex flex-col items-end">
                        <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tighter">
                            Byte<span className="text-[#5b13ec]">Plus</span>
                        </h2>
                    </div>
                    <div className="text-gray-700 text-3xl font-light">✕</div>
                    <div className="flex flex-col items-start">
                        <h2 className="text-4xl md:text-5xl font-bold text-white tracking-widest uppercase font-mono text-opacity-90">
                            Sisnet Mitra
                        </h2>
                    </div>
                </div>
                <div className="h-px w-24 bg-gradient-to-r from-transparent via-[#5b13ec] to-transparent opacity-50 mb-6"></div>
                <h1 className="text-3xl font-bold text-white tracking-[0.2em] uppercase mb-4">Creative Suite</h1>
                <div className="text-[10px] md:text-xs font-mono tracking-wide text-center opacity-80">
                    <span className="text-gray-600">&copy; 2025-2026</span>
                    <span className="mx-2 text-gray-400 italic">Research and Development Team</span>
                    <span className="text-[#5b13ec] font-bold">@</span>
                    <span className="ml-2 text-white font-bold tracking-widest uppercase">Sisnet Mitra</span>
                </div>
            </div>
        </div>
    );
};

// 2. Upload Box
const UploadBox = ({ label, file, onFileChange, previewUrl }) => (
    <div className="relative w-full aspect-[4/3] bg-[#25222d] border-2 border-dashed border-[#3e3849] rounded-xl hover:border-[#5b13ec] transition-colors group overflow-hidden">
        <input 
            type="file" 
            accept="image/*" 
            onChange={(e) => onFileChange(e.target.files[0])}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
        />
        {previewUrl || file ? (
            <img 
                src={previewUrl || (file ? URL.createObjectURL(file) : '')} 
                alt="Preview" 
                className="w-full h-full object-cover"
            />
        ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-500 group-hover:text-gray-300 transition-colors">
                <Icons.Upload />
                <span className="text-xs font-bold mt-2 uppercase tracking-wide text-center px-2">{label}</span>
            </div>
        )}
    </div>
);

// 3. Save To VOD Button
const SaveToVOD = ({ videoUrl, defaultTitle, spaces, onSaved }) => {
    const [selectedSpace, setSelectedSpace] = useState('');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');

    const handleSave = async () => {
        if (!selectedSpace) return;
        setLoading(true);
        setStatus('Mengupload...');
        try {
            await apiCall('/api/vod/upload-from-url', 'POST', {
                videoUrl: videoUrl,
                spaceName: selectedSpace,
                title: defaultTitle
            });
            setStatus('Tersimpan!');
            setTimeout(() => {
                setStatus('');
                if (onSaved) onSaved();
            }, 1500);
        } catch (e) {
            setStatus('Gagal: ' + e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex gap-2 items-center mt-4 pt-4 border-t border-[#2e2839] w-full">
            <select 
                value={selectedSpace}
                onChange={(e) => setSelectedSpace(e.target.value)}
                className="flex-1 bg-[#2e2839] text-white rounded-lg px-3 py-2 text-xs outline-none border border-transparent focus:border-[#5b13ec] transition-colors"
                disabled={loading}
            >
                <option value="">-- Save to Library --</option>
                {spaces.map(s => <option key={s.SpaceName} value={s.SpaceName}>{s.SpaceName}</option>)}
            </select>
            <button 
                onClick={handleSave}
                disabled={loading || !selectedSpace}
                className="bg-[#5b13ec] hover:bg-[#4a0fc7] text-white font-bold py-2 px-4 rounded-lg text-xs disabled:opacity-50 whitespace-nowrap transition-colors"
            >
                {loading ? 'Saving...' : status || 'Save'}
            </button>
        </div>
    );
};

// 4. Native Video Player (Multi-Codec Support)
const NativeVideoPlayer = ({ src, poster, subtitles, codec, format }) => {
    const videoRef = useRef(null);
  
    useEffect(() => {
      if (videoRef.current && videoRef.current.tagName === 'VIDEO') {
        videoRef.current.load();
      }
    }, [src, subtitles, codec]);
  
    const videoSrc = src ? `${API_BASE_URL}/api/proxy-video?url=${encodeURIComponent(src)}` : "";
    const isImageStream = codec === 'mjpeg' || format === 'image2';
    const containerClass = "w-full h-full bg-black rounded-xl overflow-hidden flex items-center justify-center shadow-inner relative group";
  
    if (!src) {
        return (
          <div className={containerClass}>
              <div className="text-gray-500 flex flex-col items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-16,16V88H152V56ZM40,56H88V88H40ZM40,104H88v48H40Zm160,96H152V168h48v32Zm0-48H152V104h48v48Zm-64,48H104V168h48v32Zm0-48H104V104h48v48ZM88,200H40V168H88v32Z"/></svg>
                  <span className="text-sm font-medium">Pilih video untuk memutar</span>
              </div>
          </div>
        );
    }
  
    if (isImageStream) {
        return (
          <div className={containerClass}>
              <img src={videoSrc} alt="Stream Preview" className="w-full h-full object-contain" />
              <div className="absolute top-2 right-2 bg-black/70 text-white text-[10px] px-2 py-1 rounded border border-white/20">MJPEG Stream</div>
          </div>
        );
    }
  
    const validSubtitles = (subtitles || []).map((sub, index) => {
          let originalUrl = sub.FinalUrl || sub.SubtitleUrl;
          if (!originalUrl) return null;
          const proxyUrl = `${API_BASE_URL}/api/proxy-subtitle?url=${encodeURIComponent(originalUrl)}`;
          return { src: proxyUrl, label: sub.Language || `Subtitle ${index + 1}`, language: sub.Language || 'en', default: index === 0 };
      }).filter(Boolean);
  
    return (
      <div className={containerClass}>
          <video ref={videoRef} className="w-full h-full object-contain" controls poster={poster} crossOrigin="anonymous" playsInline>
              <source src={videoSrc} type="video/mp4" />
              {validSubtitles.map((sub, idx) => (
                  <track key={idx} kind="subtitles" src={sub.src} srcLang={sub.language} label={sub.label} default={sub.default} />
              ))}
              Browser Anda tidak mendukung tag video HTML5.
          </video>
      </div>
    );
  };


// --- MODULES ---

// 1. Audience & Market Intel
const ModuleIntel = () => {
    const [demographic, setDemographic] = useState('Gen Z');
    const [genre, setGenre] = useState('Horror');
    const [region, setRegion] = useState('Jakarta');
    const [prompt, setPrompt] = useState('');
    const [loading, setLoading] = useState(false);
    const [personaImage, setPersonaImage] = useState(null);

    useEffect(() => {
        setPrompt(`Photorealistic portrait of a ${demographic} movie audience member from ${region} watching a ${genre} movie, cinematic lighting, highly detailed face, expressive emotion, modern casual outfit, in a movie theater setting.`);
    }, [demographic, genre, region]);

    const handleSimulate = async () => {
        setLoading(true);
        try {
            const data = await apiCall('/api/ai/generate-image', 'POST', { prompt, size: '2048x2048' });
            setPersonaImage(data.result);
        } catch(e) { alert(e.message) }
        finally { setLoading(false) }
    };

    return (
        <div className="flex flex-col gap-6 h-full">
            <div className="grid grid-cols-3 gap-4">
                {['Demographic', 'Genre', 'Region'].map((label, i) => (
                    <div key={label} className="bg-[#1c1a21] p-4 rounded-xl border border-[#2e2839]">
                        <h4 className="text-gray-500 text-xs uppercase font-bold mb-2">{label}</h4>
                        <select 
                            className="w-full bg-[#25222d] text-white p-2 rounded outline-none border border-transparent focus:border-[#5b13ec]"
                            onChange={(e) => i===0 ? setDemographic(e.target.value) : i===1 ? setGenre(e.target.value) : setRegion(e.target.value)}
                        >
                            {i===0 && ['Gen Z', 'Millennials', 'Gen X'].map(o=><option key={o}>{o}</option>)}
                            {i===1 && ['Horror', 'Romance', 'Action', 'Comedy'].map(o=><option key={o}>{o}</option>)}
                            {i===2 && ['Jakarta', 'Surabaya', 'Medan', 'Bali'].map(o=><option key={o}>{o}</option>)}
                        </select>
                    </div>
                ))}
            </div>
            
            <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#1c1a21] p-6 rounded-xl border border-[#2e2839] flex flex-col">
                    <div>
                        <h3 className="text-xl font-bold text-white mb-2">Audience Simulation</h3>
                        <p className="text-gray-400 text-sm mb-4">AI memprediksi profil visual penonton berdasarkan data demografi.</p>
                        <div className="space-y-2 mb-4">
                            <div className="flex justify-between text-xs text-gray-300"><span>Minat (Interest)</span><span className="text-[#5b13ec]">High (88%)</span></div>
                            <div className="w-full bg-gray-700 h-1.5 rounded-full"><div className="bg-[#5b13ec] h-1.5 rounded-full" style={{width: '88%'}}></div></div>
                            <div className="flex justify-between text-xs text-gray-300 pt-2"><span>Spending Power</span><span className="text-green-400">Medium</span></div>
                            <div className="w-full bg-gray-700 h-1.5 rounded-full"><div className="bg-green-400 h-1.5 rounded-full" style={{width: '60%'}}></div></div>
                        </div>
                    </div>
                    
                    <div className="flex-1 flex flex-col gap-2">
                        <label className="text-xs font-bold text-gray-500 uppercase">Prompt (Editable)</label>
                        <textarea 
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            className="w-full bg-[#25222d] text-white p-3 rounded-lg border border-[#3e3849] flex-1 text-sm outline-none focus:border-[#5b13ec] resize-none min-h-[100px]"
                        />
                    </div>

                    <button 
                        onClick={handleSimulate} 
                        disabled={loading}
                        className="w-full bg-[#5b13ec] hover:bg-[#4a0fc7] text-white py-3 rounded-lg font-bold flex items-center justify-center gap-2 mt-4"
                    >
                        {loading ? 'Simulating...' : 'Visualisasikan Persona'}
                    </button>
                </div>
                <div className="bg-[#25222d] rounded-xl border border-[#2e2839] flex items-center justify-center overflow-hidden relative">
                    {personaImage ? (
                        <img src={personaImage} alt="Persona" className="w-full h-full object-cover" />
                    ) : (
                        <div className="text-center text-gray-500">
                            <Icons.Intel />
                            <p className="text-xs mt-2">Visual Persona akan muncul di sini</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// 2. Creative Assistant
const ModuleCreative = ({ spaces }) => {
    const [filmName, setFilmName] = useState('');
    const [platform, setPlatform] = useState('TikTok');
    const [hookType, setHookType] = useState('Suspense');
    const [loading, setLoading] = useState(false);
    const [generatedHook, setGeneratedHook] = useState(null);
    const [prompt, setPrompt] = useState('');

    useEffect(() => {
        if(filmName) {
            setPrompt(`Movie teaser hook for ${filmName}, style ${hookType}, format ${platform}, high tension, dramatic camera movement, 3 seconds intro, cinematic lighting.`);
        }
    }, [filmName, platform, hookType]);

    const handleGenHook = async () => {
        if(!filmName) return alert("Masukkan judul film");
        setLoading(true);
        try {
            const task = await apiCall('/api/ai/generate-video', 'POST', { 
                prompt,
                duration: 5, 
                ratio: platform === 'TikTok' ? '9:16' : '16:9', 
                resolution: '720p' 
            });
            
            const interval = setInterval(async () => {
                try {
                    const poll = await apiCall(`/api/ai/task/${task.taskId}`);
                    if(poll.status === 'succeeded') {
                        clearInterval(interval);
                        setGeneratedHook(poll.videoUrl);
                        setLoading(false);
                    } else if(poll.status === 'failed') {
                        clearInterval(interval);
                        alert("Video generation failed");
                        setLoading(false);
                    }
                } catch(e) {
                     clearInterval(interval);
                     setLoading(false);
                }
            }, 5000);
            
        } catch(e) { 
            alert(e.message);
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <div className="bg-[#1c1a21] p-6 rounded-xl border border-[#2e2839]">
                <h3 className="text-lg font-bold text-white mb-4">Social Media Visual Hook Generator</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <input 
                        placeholder="Judul Film / Sinopsis Singkat" 
                        className="bg-[#25222d] text-white p-3 rounded-lg border border-[#3e3849] outline-none focus:border-[#5b13ec]"
                        value={filmName} onChange={(e)=>setFilmName(e.target.value)}
                    />
                    <select className="bg-[#25222d] text-white p-3 rounded-lg border border-[#3e3849]" onChange={(e)=>setPlatform(e.target.value)}>
                        <option value="TikTok">TikTok (9:16)</option>
                        <option value="Instagram">Feed (4:5)</option>
                        <option value="YouTube">Shorts (9:16)</option>
                    </select>
                    <select className="bg-[#25222d] text-white p-3 rounded-lg border border-[#3e3849]" onChange={(e)=>setHookType(e.target.value)}>
                        <option value="Suspense">Suspense / Jumpscare</option>
                        <option value="Emotional">Emotional / Drama</option>
                        <option value="Action">Action / Fast Cut</option>
                    </select>
                </div>

                <div className="mb-4">
                    <label className="text-xs font-bold text-gray-500 uppercase block mb-2">Prompt Editor (Manual Override)</label>
                    <textarea 
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                        className="w-full bg-[#25222d] text-white p-3 rounded-lg border border-[#3e3849] outline-none focus:border-[#5b13ec] resize-none h-20 text-sm"
                        placeholder="Prompt akan otomatis terisi..."
                    />
                </div>

                <button 
                    onClick={handleGenHook}
                    disabled={loading}
                    className="bg-gradient-to-r from-[#5b13ec] to-[#8b5cf6] text-white px-6 py-3 rounded-lg font-bold w-full disabled:opacity-50"
                >
                    {loading ? 'Generating Visual Hook...' : 'Generate 3s Viral Hook'}
                </button>
            </div>

            <div className="flex gap-4 h-[400px]">
                <div className="w-1/3 bg-[#25222d] rounded-xl border border-[#2e2839] p-4">
                    <h4 className="text-gray-400 text-xs font-bold uppercase mb-3">AI Caption Suggestion</h4>
                    <div className="space-y-3">
                        <div className="bg-[#1c1a21] p-3 rounded text-sm text-gray-300">
                            "Jangan nonton sendirian! 👻 {filmName} bakal bikin tidurmu ga nyenyak malam ini. #HorrorMovies"
                        </div>
                        <div className="bg-[#1c1a21] p-3 rounded text-sm text-gray-300">
                            "Plot twist di menit ke-15 ga ketebak! 🔥 Siapa yang udah siap mental buat {filmName}?"
                        </div>
                    </div>
                </div>
                <div className="flex-1 bg-black rounded-xl border border-[#2e2839] overflow-hidden flex flex-col items-center justify-center relative">
                    {generatedHook ? (
                        <>
                            <video src={generatedHook} controls autoPlay loop className="h-full w-full object-contain" />
                            <div className="absolute bottom-4 right-4">
                                <SaveToVOD videoUrl={generatedHook} defaultTitle={`Hook - ${filmName}`} spaces={spaces} />
                            </div>
                        </>
                    ) : (
                        <div className="text-center text-gray-600">
                            {loading ? <div className="animate-spin w-8 h-8 border-4 border-[#5b13ec] border-t-transparent rounded-full mx-auto mb-2"/> : <Icons.Video />}
                            <p className="text-xs mt-2">{loading ? "Rendering Hook..." : "Visual Hook Preview"}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// 3. Campaign Planner
const ModulePlanner = ({ spaces }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [assetUrl, setAssetUrl] = useState(null);
    const [prompt, setPrompt] = useState('');

    const timeline = [
        { day: 'H-60', label: 'Teaser Poster', type: 'image', basePrompt: 'Movie poster for campaign teaser, dark, mysterious, cinematic' },
        { day: 'H-30', label: 'Official Trailer', type: 'video', basePrompt: 'Movie trailer intro, epic, action packed, cinematic lighting' },
        { day: 'H-14', label: 'Character Reveal', type: 'image', basePrompt: 'Character portrait, hero pose, detailed costume, dramatic lighting' },
        { day: 'H-7', label: 'Countdown 7 Days', type: 'video', basePrompt: 'Countdown timer 7, motion graphics, high energy' },
        { day: 'H-0', label: 'Release Day Post', type: 'image', basePrompt: 'Now Showing poster, celebratory, vibrant colors, cinema hall background' },
    ];

    const handleSelectDate = (item) => {
        setSelectedDate(item);
        setPrompt(item.basePrompt);
        setAssetUrl(null);
    };

    const generateAsset = async () => {
        if (!selectedDate) return;
        setLoading(true);
        setAssetUrl(null);
        try {
            if(selectedDate.type === 'image') {
                const data = await apiCall('/api/ai/generate-image', 'POST', { 
                    prompt: prompt, size: '2K' 
                });
                setAssetUrl(data.result);
            } else {
                const task = await apiCall('/api/ai/generate-video', 'POST', { 
                    prompt: prompt, duration: 5 
                });
                
                const interval = setInterval(async () => {
                    try {
                        const poll = await apiCall(`/api/ai/task/${task.taskId}`);
                        if(poll.status === 'succeeded') {
                            clearInterval(interval);
                            setAssetUrl(poll.videoUrl);
                            setLoading(false);
                        } else if(poll.status === 'failed') {
                            clearInterval(interval);
                            alert("Video generation failed");
                            setLoading(false);
                        }
                    } catch(e) {
                         clearInterval(interval);
                         setLoading(false);
                    }
                }, 5000);
                return; 
            }
        } catch(e) { alert(e.message) }
        finally { if(selectedDate.type === 'image') setLoading(false) }
    };

    return (
        <div className="flex flex-col gap-6 h-full">
            <div className="overflow-x-auto pb-4">
                <div className="flex gap-4 min-w-max">
                    {timeline.map((item, idx) => (
                        <div 
                            key={idx} 
                            onClick={() => handleSelectDate(item)}
                            className={`w-40 h-32 rounded-xl border-2 flex flex-col items-center justify-center cursor-pointer transition-all ${selectedDate?.label === item.label ? 'border-[#5b13ec] bg-[#5b13ec]/10' : 'border-[#2e2839] bg-[#1c1a21] hover:border-gray-500'}`}
                        >
                            <span className="text-[#5b13ec] font-bold text-xl mb-1">{item.day}</span>
                            <span className="text-gray-400 text-xs uppercase font-bold text-center px-2">{item.label}</span>
                            <span className="text-[10px] text-gray-600 mt-2 bg-black/30 px-2 py-0.5 rounded">{item.type.toUpperCase()}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex-1 bg-[#1c1a21] border border-[#2e2839] rounded-2xl p-6 flex flex-col">
                {selectedDate ? (
                    <div className="flex gap-6 h-full">
                        <div className="w-1/3 flex flex-col gap-4">
                            <h3 className="text-white font-bold">{selectedDate.label} Asset</h3>
                            <div>
                                <label className="text-xs text-gray-500 uppercase font-bold">Prompt</label>
                                <textarea 
                                    className="w-full bg-[#25222d] text-white p-3 rounded-lg border border-[#3e3849] text-sm h-32 mt-2 outline-none focus:border-[#5b13ec]"
                                    value={prompt}
                                    onChange={(e) => setPrompt(e.target.value)}
                                />
                            </div>
                            <button 
                                onClick={generateAsset}
                                disabled={loading}
                                className="bg-[#5b13ec] hover:bg-[#4a0fc7] text-white py-3 rounded-lg font-bold disabled:opacity-50"
                            >
                                {loading ? 'Generating...' : 'Generate Asset'}
                            </button>
                        </div>
                        <div className="flex-1 bg-black/30 rounded-xl border border-[#2e2839] flex flex-col items-center justify-center relative">
                            {loading ? (
                                <div className="w-10 h-10 border-4 border-[#5b13ec] border-t-transparent rounded-full animate-spin"/>
                            ) : assetUrl ? (
                                <>
                                    {selectedDate.type === 'video' ? (
                                        <video src={assetUrl} controls className="max-h-full max-w-full rounded-lg" />
                                    ) : (
                                        <img src={assetUrl} alt="Asset" className="max-h-full max-w-full rounded-lg" />
                                    )}
                                    {/* Video Save is only for videos for now, images can be downloaded */}
                                    {selectedDate.type === 'video' && (
                                        <div className="absolute bottom-4 right-4">
                                            <SaveToVOD videoUrl={assetUrl} defaultTitle={`${selectedDate.day} - ${selectedDate.label}`} spaces={spaces} />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="text-gray-500 text-sm">Preview area</div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="h-full flex flex-col items-center justify-center text-gray-600">
                        <Icons.Planner />
                        <p className="mt-4 text-sm">Pilih Timeline Card di atas untuk memulai.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

// 4. Performance Tracker (Simulation)
const ModulePerformance = () => {
    return (
        <div className="flex flex-col gap-6 h-full">
            <div className="grid grid-cols-4 gap-4">
                <div className="bg-[#1c1a21] p-4 rounded-xl border border-[#2e2839]">
                    <p className="text-gray-500 text-xs font-bold uppercase">Total Views</p>
                    <h3 className="text-2xl font-bold text-white mt-1">2.4M</h3>
                    <span className="text-green-500 text-xs">↑ 12% vs last week</span>
                </div>
                <div className="bg-[#1c1a21] p-4 rounded-xl border border-[#2e2839]">
                    <p className="text-gray-500 text-xs font-bold uppercase">Engagement Rate</p>
                    <h3 className="text-2xl font-bold text-white mt-1">4.8%</h3>
                    <span className="text-green-500 text-xs">↑ 0.5% vs avg</span>
                </div>
                <div className="bg-[#1c1a21] p-4 rounded-xl border border-[#2e2839]">
                    <p className="text-gray-500 text-xs font-bold uppercase">Sentiment Score</p>
                    <h3 className="text-2xl font-bold text-[#5b13ec] mt-1">Positive</h3>
                    <span className="text-gray-500 text-xs">Based on 15k comments</span>
                </div>
                <div className="bg-[#1c1a21] p-4 rounded-xl border border-[#2e2839]">
                    <p className="text-gray-500 text-xs font-bold uppercase">Viral Potential</p>
                    <h3 className="text-2xl font-bold text-white mt-1">High</h3>
                    <span className="text-[#5b13ec] text-xs">AI Predicted</span>
                </div>
            </div>

            <div className="flex-1 bg-[#1c1a21] rounded-xl border border-[#2e2839] p-6 relative overflow-hidden flex flex-col justify-center items-center">
                 {/* Visual Mockup for Chart */}
                 <div className="w-full h-full flex items-end gap-2 px-10 pb-10 opacity-50">
                    {[40, 60, 45, 70, 85, 60, 75, 90, 65, 80, 95, 100].map((h, i) => (
                        <div key={i} className="flex-1 bg-gradient-to-t from-[#5b13ec] to-blue-500 rounded-t-sm hover:opacity-100 transition-opacity cursor-pointer" style={{height: `${h}%`}}></div>
                    ))}
                 </div>
                 <div className="absolute inset-0 flex items-center justify-center">
                    <div className="bg-black/80 backdrop-blur px-6 py-3 rounded-full border border-[#2e2839] text-center">
                        <p className="text-gray-400 text-xs mb-1">AI Prediction Model</p>
                        <p className="text-white font-bold">Campaign "Horror Summer" is trending upward</p>
                    </div>
                 </div>
            </div>
        </div>
    );
};

// 5. Repurposing Engine (Simulation)
const ModuleRepurpose = ({ spaces }) => {
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [currentStep, setCurrentStep] = useState('');
    const [progress, setProgress] = useState(0);
    const [clips, setClips] = useState([]);
    const [selectedClip, setSelectedClip] = useState(null);

    // ── Helpers ──────────────────────────────────────────────

    /** Read video duration without mounting a DOM element permanently */
    const getVideoDuration = (videoFile) =>
        new Promise((resolve, reject) => {
            const v = document.createElement('video');
            const url = URL.createObjectURL(videoFile);
            v.src = url;
            v.onloadedmetadata = () => { URL.revokeObjectURL(url); resolve(v.duration); };
            v.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Cannot read video metadata')); };
        });

    /** Extract a single JPEG frame at `timeSeconds` from a File.
     *  Uses `loadeddata` (not `loadedmetadata`) so pixel data is available,
     *  then waits a rAF tick after `seeked` so the browser has actually
     *  painted the frame before we snapshot — prevents black canvases. */
    const extractFrame = (videoFile, timeSeconds) =>
        new Promise((resolve, reject) => {
            const v = document.createElement('video');
            v.preload = 'auto';
            v.muted = true;
            v.playsInline = true;

            const url = URL.createObjectURL(videoFile);
            v.src = url;

            const cleanup = () => URL.revokeObjectURL(url);

            const capture = () => {
                // rAF tick lets the browser paint the decoded frame first
                requestAnimationFrame(() => {
                    try {
                        const canvas = document.createElement('canvas');
                        canvas.width  = v.videoWidth  || 1280;
                        canvas.height = v.videoHeight || 720;
                        canvas.getContext('2d').drawImage(v, 0, 0, canvas.width, canvas.height);
                        cleanup();
                        canvas.toBlob(
                            (blob) => blob ? resolve(blob) : reject(new Error('Canvas toBlob returned null')),
                            'image/jpeg',
                            0.92
                        );
                    } catch (err) {
                        cleanup();
                        reject(err);
                    }
                });
            };

            // `loadeddata` = current frame decoded and ready, safe to seek
            v.addEventListener('loadeddata', () => {
                const target = Math.min(timeSeconds, v.duration - 0.1);
                if (Math.abs(v.currentTime - target) < 0.05) {
                    // Already at the right frame (e.g. seeking to 0)
                    capture();
                } else {
                    v.currentTime = target;
                }
            }, { once: true });

            v.addEventListener('seeked', capture, { once: true });
            v.addEventListener('error',  () => { cleanup(); reject(new Error('Video load failed during frame extraction')); }, { once: true });
        });

    /** Upload a Blob as an image and return its public URL */
    const uploadFrameBlob = async (blob, name) => {
        const fd = new FormData();
        fd.append('image', new File([blob], name, { type: 'image/jpeg' }));
        const res = await fetch(`${API_BASE_URL}/api/utils/upload-image`, { method: 'POST', body: fd });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Frame upload failed');
        return data.imageUrl;
    };

    /** Poll a task until it succeeds or fails, returns videoUrl */
    const pollTask = (taskId) =>
        new Promise((resolve, reject) => {
            const iv = setInterval(async () => {
                try {
                    const poll = await apiCall(`/api/ai/task/${taskId}`);
                    if (poll.status === 'succeeded') { clearInterval(iv); resolve(poll.videoUrl); }
                    else if (poll.status === 'failed') { clearInterval(iv); reject(new Error('AI generation failed')); }
                } catch (e) { clearInterval(iv); reject(e); }
            }, 5000);
        });

    // ── Clip definitions (resolved once we know duration) ────

    const buildClipDefs = (duration) => {
        const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s) % 60).padStart(2, '0')}`;
        return [
            {
                label:      'Viral Hook',
                timeLabel:  `${fmt(0)} – ${fmt(5)}`,
                time:       1,                          // seek to 1 s for first-frame
                prompt:     'Cinematic movie viral hook, high-tension dramatic opening scene, fast-paced social media style, expressive close-up, 5 seconds',
                viralScore: '98/100',
                scoreColor: 'text-green-400',
                bgAccent:   'border-green-500/30',
            },
            {
                label:      'Mid Highlight',
                timeLabel:  `~${fmt(duration / 2)}`,
                time:       duration / 2,
                prompt:     'Movie highlight reel clip, peak emotional or action moment, dynamic camera movement, cinematic color grading, 5 seconds',
                viralScore: '91/100',
                scoreColor: 'text-yellow-400',
                bgAccent:   'border-yellow-500/30',
            },
            {
                label:      'Climax Punch',
                timeLabel:  `~${fmt(duration * 0.8)}`,
                time:       duration * 0.8,
                prompt:     'Epic movie climax scene, high-energy confrontation or revelation, quick cuts, dramatic cinematic lighting, 5 seconds',
                viralScore: '88/100',
                scoreColor: 'text-orange-400',
                bgAccent:   'border-orange-500/30',
            },
        ];
    };

    // ── Main pipeline ─────────────────────────────────────────

    const handleProcess = async () => {
        if (!file) return;
        setProcessing(true);
        setClips([]);
        setSelectedClip(null);
        setProgress(0);

        try {
            // 1. Read metadata
            setCurrentStep('Reading video metadata…');
            const duration = await getVideoDuration(file);
            const defs = buildClipDefs(duration);
            setProgress(8);

            // 2. Extract 3 frames client-side
            setCurrentStep('Extracting key frames from video…');
            const frameBlobs = [];
            for (let i = 0; i < defs.length; i++) {
                const blob = await extractFrame(file, defs[i].time);
                frameBlobs.push(blob);
                setProgress(8 + (i + 1) * 8);   // 16 / 24 / 32
            }

            // 3. Upload frames to get public URLs
            setCurrentStep('Uploading reference frames…');
            const frameUrls = [];
            for (let i = 0; i < frameBlobs.length; i++) {
                const url = await uploadFrameBlob(frameBlobs[i], `repurpose_frame_${i}_${Date.now()}.jpg`);
                frameUrls.push(url);
                setProgress(32 + (i + 1) * 8);  // 40 / 48 / 56
            }

            // 4. Kick off 3 parallel video generations
            setCurrentStep('Starting AI generation for 3 clips…');
            const tasks = await Promise.all(
                defs.map((def, i) =>
                    apiCall('/api/ai/generate-video', 'POST', {
                        prompt:        def.prompt,
                        duration:      5,
                        ratio:         '9:16',
                        resolution:    '720p',
                        firstFrameUrl: frameUrls[i],
                    })
                )
            );
            setProgress(65);

            // 5. Poll all 3 concurrently (each resolves independently)
            setCurrentStep('Rendering AI clips — this may take a minute…');
            const resolvedUrls = new Array(3).fill(null);
            let done = 0;

            await Promise.all(
                tasks.map((task, i) =>
                    pollTask(task.taskId).then((videoUrl) => {
                        resolvedUrls[i] = videoUrl;
                        done++;
                        setProgress(65 + Math.round((done / 3) * 35));
                        // Surface clips progressively as they finish
                        setClips(defs.map((def, j) => ({
                            ...def,
                            videoUrl: resolvedUrls[j] || null,
                            pending:  resolvedUrls[j] === null,
                        })));
                    })
                )
            );

            // Final state (all resolved)
            setClips(defs.map((def, i) => ({ ...def, videoUrl: resolvedUrls[i], pending: false })));
            setSelectedClip(0);

        } catch (e) {
            alert('Repurposing error: ' + e.message);
        } finally {
            setProcessing(false);
            setCurrentStep('');
        }
    };

    const handleFileChange = (f) => {
        setFile(f);
        setClips([]);
        setSelectedClip(null);
        setProgress(0);
        if (f) setPreviewUrl(URL.createObjectURL(f));
    };

    // ── Render ────────────────────────────────────────────────

    return (
        <div className="flex flex-col gap-6 h-full">

            {/* ── Upload + Controls ── */}
            <div className="bg-[#1c1a21] p-6 rounded-xl border border-[#2e2839]">
                <div className="flex items-start justify-between mb-2">
                    <div>
                        <h3 className="text-lg font-bold text-white">Smart Repurposing Engine</h3>
                        <p className="text-sm text-gray-400 mt-1">
                            Upload a trailer — AI extracts 3 key frames and generates short viral clips for each.
                        </p>
                    </div>
                    <span className="text-[10px] font-mono bg-[#5b13ec]/20 text-[#5b13ec] px-2 py-1 rounded border border-[#5b13ec]/30 uppercase tracking-wider">
                        BytePlus AI
                    </span>
                </div>

                <div className="flex gap-6 mt-4">
                    {/* Upload box */}
                    <div className="w-56 flex-shrink-0">
                        <div className="relative w-full aspect-video bg-[#25222d] border-2 border-dashed border-[#3e3849] rounded-xl hover:border-[#5b13ec] transition-colors group overflow-hidden">
                            <input
                                type="file"
                                accept="video/*"
                                onChange={(e) => handleFileChange(e.target.files[0])}
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                disabled={processing}
                            />
                            {previewUrl ? (
                                <video
                                    src={previewUrl}
                                    className="w-full h-full object-cover"
                                    muted
                                    playsInline
                                />
                            ) : (
                                <div className="absolute inset-0 flex flex-col items-center justify-center text-gray-500 group-hover:text-gray-300 transition-colors">
                                    <Icons.Upload />
                                    <span className="text-[10px] font-bold mt-2 uppercase tracking-wide text-center px-2">
                                        Upload Trailer (MP4)
                                    </span>
                                </div>
                            )}
                        </div>
                        {file && (
                            <p className="text-[10px] text-gray-500 mt-1 truncate text-center">{file.name}</p>
                        )}
                    </div>

                    {/* Status / trigger area */}
                    <div className="flex-1 flex flex-col justify-center gap-4">
                        {!processing && !clips.length && (
                            <>
                                {/* Pipeline preview */}
                                <div className="grid grid-cols-3 gap-3 text-center">
                                    {[
                                        { step: '01', label: 'Extract Frames', sub: 'At 0s, mid, 80%' },
                                        { step: '02', label: 'Upload Refs',    sub: 'JPEG → public URL' },
                                        { step: '03', label: 'AI Generate',    sub: '3× 5s clips 9:16' },
                                    ].map(({ step, label, sub }) => (
                                        <div key={step} className="bg-[#25222d] rounded-lg p-3 border border-[#3e3849]">
                                            <span className="text-[#5b13ec] font-black text-xs">{step}</span>
                                            <p className="text-white text-xs font-bold mt-1">{label}</p>
                                            <p className="text-gray-500 text-[10px] mt-0.5">{sub}</p>
                                        </div>
                                    ))}
                                </div>
                                <button
                                    onClick={handleProcess}
                                    disabled={!file}
                                    className="bg-[#5b13ec] hover:bg-[#4a0fc7] text-white px-8 py-3 rounded-lg font-bold disabled:opacity-40 w-fit transition-colors"
                                >
                                    Start AI Analysis
                                </button>
                            </>
                        )}

                        {processing && (
                            <div className="space-y-3">
                                <div className="flex justify-between text-xs text-white font-mono">
                                    <span>{currentStep}</span>
                                    <span>{progress}%</span>
                                </div>
                                <div className="w-full bg-[#25222d] h-2 rounded-full overflow-hidden border border-[#3e3849]">
                                    <div
                                        className="bg-gradient-to-r from-[#5b13ec] to-blue-500 h-full rounded-full transition-all duration-500"
                                        style={{ width: `${progress}%` }}
                                    />
                                </div>
                                <div className="flex gap-2 mt-2">
                                    {['Viral Hook', 'Mid Highlight', 'Climax Punch'].map((label, i) => (
                                        <div key={i} className="flex items-center gap-1.5 text-[10px] text-gray-500">
                                            <div className={`w-1.5 h-1.5 rounded-full ${progress >= 65 + i * 12 ? 'bg-[#5b13ec] animate-pulse' : 'bg-gray-700'}`} />
                                            {label}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {!processing && clips.length > 0 && (
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 rounded-full bg-green-500" />
                                <span className="text-sm text-green-400 font-bold">
                                    {clips.filter(c => c.videoUrl).length} / {clips.length} clips generated
                                </span>
                                <button
                                    onClick={() => { setClips([]); setFile(null); setPreviewUrl(null); setProgress(0); }}
                                    className="ml-auto text-xs text-gray-500 hover:text-white border border-[#3e3849] px-3 py-1.5 rounded-lg transition-colors"
                                >
                                    Reset
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* ── Results ── */}
            {(clips.length > 0 || processing) && (
                <div className="flex gap-6 flex-1 min-h-0">

                    {/* Clip list */}
                    <div className="w-64 flex-shrink-0 flex flex-col gap-3">
                        {(clips.length ? clips : ['Viral Hook', 'Mid Highlight', 'Climax Punch'].map(label => ({ label, pending: true }))).map((clip, i) => (
                            <div
                                key={i}
                                onClick={() => clip.videoUrl && setSelectedClip(i)}
                                className={`p-4 rounded-xl border-2 transition-all ${
                                    clip.videoUrl
                                        ? `cursor-pointer ${selectedClip === i ? 'border-[#5b13ec] bg-[#5b13ec]/10' : `border-[#2e2839] hover:border-gray-500 ${clip.bgAccent || ''} bg-[#1c1a21]`}`
                                        : 'border-[#2e2839] bg-[#1c1a21] opacity-60 cursor-not-allowed'
                                }`}
                            >
                                <div className="flex items-center justify-between mb-2">
                                    <span className={`text-xs font-black uppercase tracking-wide ${selectedClip === i && clip.videoUrl ? 'text-[#5b13ec]' : 'text-white'}`}>
                                        {clip.label}
                                    </span>
                                    {clip.pending || (!clip.videoUrl && processing) ? (
                                        <div className="w-3 h-3 border-2 border-[#5b13ec] border-t-transparent rounded-full animate-spin" />
                                    ) : clip.videoUrl ? (
                                        <span className={`text-[10px] font-bold ${clip.scoreColor || 'text-green-400'}`}>
                                            {clip.viralScore}
                                        </span>
                                    ) : null}
                                </div>
                                <p className="text-[10px] text-gray-500 font-mono">{clip.timeLabel || '—'}</p>
                                {clip.videoUrl && (
                                    <div className="mt-2 aspect-video rounded overflow-hidden bg-black">
                                        <video
                                            src={clip.videoUrl}
                                            className="w-full h-full object-cover"
                                            muted
                                            loop
                                            autoPlay={selectedClip === i}
                                            playsInline
                                        />
                                    </div>
                                )}
                                {(!clip.videoUrl) && (
                                    <div className="mt-2 aspect-video rounded bg-[#25222d] flex items-center justify-center">
                                        <span className="text-[10px] text-gray-600">Generating…</span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Main player */}
                    <div className="flex-1 bg-[#1c1a21] border border-[#2e2839] rounded-xl overflow-hidden flex flex-col">
                        {selectedClip !== null && clips[selectedClip]?.videoUrl ? (
                            <>
                                <div className="flex-1 bg-black flex items-center justify-center relative">
                                    <video
                                        key={clips[selectedClip].videoUrl}
                                        src={clips[selectedClip].videoUrl}
                                        controls
                                        autoPlay
                                        loop
                                        className="max-h-full max-w-full"
                                        style={{ maxHeight: '420px' }}
                                    />
                                    <div className="absolute top-3 left-3 bg-black/70 px-3 py-1 rounded-full border border-white/10">
                                        <span className="text-[10px] text-white font-bold uppercase tracking-wider">
                                            {clips[selectedClip].label}
                                        </span>
                                    </div>
                                    <div className={`absolute top-3 right-3 bg-black/70 px-3 py-1 rounded-full border border-white/10`}>
                                        <span className={`text-[10px] font-bold ${clips[selectedClip].scoreColor}`}>
                                            Viral Score: {clips[selectedClip].viralScore}
                                        </span>
                                    </div>
                                </div>

                                <div className="p-4 border-t border-[#2e2839] flex items-center justify-between gap-4">
                                    <div>
                                        <p className="text-white font-bold text-sm">{clips[selectedClip].label}</p>
                                        <p className="text-gray-500 text-xs font-mono mt-0.5">{clips[selectedClip].timeLabel} · 5s · 9:16 · 720p</p>
                                    </div>
                                    <div className="flex items-center gap-3">
                                        <a
                                            href={clips[selectedClip].videoUrl}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="bg-white text-black px-4 py-2 rounded-lg text-xs font-bold hover:bg-gray-200 transition-colors"
                                        >
                                            Download
                                        </a>
                                        {spaces?.length > 0 && (
                                            <SaveToVOD
                                                videoUrl={clips[selectedClip].videoUrl}
                                                defaultTitle={`Repurpose – ${clips[selectedClip].label}`}
                                                spaces={spaces}
                                            />
                                        )}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="h-full flex flex-col items-center justify-center text-gray-600 gap-3">
                                {processing ? (
                                    <>
                                        <div className="w-10 h-10 border-4 border-[#5b13ec] border-t-transparent rounded-full animate-spin" />
                                        <p className="text-sm">{currentStep}</p>
                                    </>
                                ) : (
                                    <>
                                        <Icons.Repurpose />
                                        <p className="text-sm">Select a clip from the left to preview</p>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Empty state when no clips yet and not processing */}
            {!processing && !clips.length && (
                <div className="flex-1 bg-[#1c1a21] border border-[#2e2839] rounded-xl flex items-center justify-center text-gray-600 border-dashed">
                    <div className="text-center">
                        <Icons.Repurpose />
                        <p className="text-sm mt-2">Generated clips will appear here</p>
                    </div>
                </div>
            )}
        </div>
    );
};

// 6. Content Gen Tools (Poster, Merch, Character, Freestyle)
const ModuleGenTools = ({ spaces }) => {
    const [tool, setTool] = useState('freestyle');
    const [format, setFormat] = useState('image'); // 'image' or 'video'
    const [prompt, setPrompt] = useState('');
    const [refImage, setRefImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleRun = async () => {
        if(!prompt) return alert("Prompt needed");
        setLoading(true);
        setResult(null);
        try {
            let finalPrompt = prompt;
            let ratio = '1:1';
            let size = '2K';

            // Preset Logic for specific tools (only if Image format is selected or relevant)
            if (format === 'image') {
                if(tool === 'poster') {
                    finalPrompt = `Movie Poster, ${prompt}, professional typography style, cinematic lighting, vertical layout`;
                    ratio = '2:3'; 
                    size = '2048x2048';
                } else if (tool === 'merch') {
                    finalPrompt = `T-shirt design graphic, ${prompt}, vector style, isolated on black background, high contrast`;
                } else if (tool === 'bible') {
                    finalPrompt = `Character design sheet, ${prompt}, front view, side view, close up, detailed costume, concept art style`;
                    ratio = '16:9';
                }
            }

            let refUrl = null;
            if (refImage) {
                const fd = new FormData(); fd.append('image', refImage);
                const up = await fetch(`${API_BASE_URL}/api/utils/upload-image`, {method:'POST', body:fd});
                refUrl = (await up.json()).imageUrl;
            }

            if (format === 'image') {
                const data = await apiCall('/api/ai/generate-image', 'POST', { prompt: finalPrompt, size, watermark: true });
                setResult({ type: 'image', url: data.result });
            } else {
                // Video Generation
                const task = await apiCall('/api/ai/generate-video', 'POST', { 
                    prompt: finalPrompt, 
                    duration: 5,
                    firstFrameUrl: refUrl // Use ref image as first frame if available
                });
                
                // Polling for video
                const interval = setInterval(async () => {
                    try {
                        const poll = await apiCall(`/api/ai/task/${task.taskId}`);
                        if(poll.status === 'succeeded') {
                            clearInterval(interval);
                            setResult({ type: 'video', url: poll.videoUrl });
                            setLoading(false);
                        } else if(poll.status === 'failed') {
                            clearInterval(interval);
                            alert("Video generation failed");
                            setLoading(false);
                        }
                    } catch(e) {
                         clearInterval(interval);
                         setLoading(false);
                    }
                }, 5000);
                return; // Return early to avoid setting loading false immediately
            }

        } catch(e) { alert(e.message) }
        finally { if(format === 'image') setLoading(false) }
    };

    return (
        <div className="flex gap-6 h-full">
            <div className="w-1/3 flex flex-col gap-4">
                {/* Format Toggle */}
                <div className="bg-[#1c1a21] p-1 rounded-xl border border-[#2e2839] flex">
                    <button 
                        onClick={() => setFormat('image')}
                        className={`flex-1 py-2 text-xs font-bold uppercase rounded-lg transition-all ${format === 'image' ? 'bg-[#5b13ec] text-white' : 'text-gray-500 hover:text-white'}`}
                    >
                        Image Asset
                    </button>
                    <button 
                        onClick={() => setFormat('video')}
                        className={`flex-1 py-2 text-xs font-bold uppercase rounded-lg transition-all ${format === 'video' ? 'bg-[#5b13ec] text-white' : 'text-gray-500 hover:text-white'}`}
                    >
                        Video Asset
                    </button>
                </div>

                {/* Tool Selector (Presets) */}
                <div className="bg-[#1c1a21] p-1 rounded-xl border border-[#2e2839] flex flex-wrap gap-1">
                    {['freestyle', 'poster', 'merch', 'bible'].map(t => (
                        <button 
                            key={t}
                            onClick={() => setTool(t)}
                            className={`flex-1 min-w-[45%] py-2 text-[10px] font-bold uppercase rounded-lg transition-all ${tool === t ? 'bg-[#2e2839] text-white border border-[#5b13ec]' : 'text-gray-500 hover:text-white hover:bg-[#2e2839]'}`}
                        >
                            {t}
                        </button>
                    ))}
                </div>

                <div className="bg-[#1c1a21] p-6 rounded-xl border border-[#2e2839] flex flex-col gap-4 flex-1">
                    <h3 className="text-white font-bold mb-2 uppercase tracking-wider text-sm">
                        {format} Generator: {tool}
                    </h3>
                    <p className="text-xs text-gray-400 mb-4">
                        {tool === 'freestyle' && "Mode bebas. Gunakan prompt spesifik Anda untuk hasil maksimal."}
                        {tool === 'poster' && "Optimized untuk rasio vertikal dan pencahayaan sinematik."}
                        {tool === 'merch' && "Desain grafis terisolasi (vektor style) untuk kebutuhan cetak."}
                        {tool === 'bible' && "Lembar referensi karakter untuk konsistensi produksi."}
                    </p>

                    <UploadBox label="Ref Image (Optional)" file={refImage} onFileChange={setRefImage} />

                    <textarea 
                        className="bg-[#25222d] text-white p-3 rounded-lg border border-[#3e3849] flex-1 text-sm outline-none focus:border-[#5b13ec] resize-none mt-2"
                        placeholder={`Deskripsi detail ${format} yang diinginkan...`}
                        value={prompt} onChange={(e)=>setPrompt(e.target.value)}
                    />

                    <button 
                        onClick={handleRun}
                        disabled={loading}
                        className="bg-[#5b13ec] hover:bg-[#4a0fc7] text-white py-3 rounded-lg font-bold disabled:opacity-50"
                    >
                        {loading ? 'Generating...' : `Create ${format === 'image' ? 'Image' : 'Video'}`}
                    </button>
                </div>
            </div>

            <div className="flex-1 bg-[#1c1a21] border border-[#2e2839] rounded-xl flex items-center justify-center p-4 relative group overflow-hidden">
                {result ? (
                    <>
                        {result.type === 'video' ? (
                             <>
                                <video src={result.url} controls className="max-w-full max-h-full rounded shadow-lg" />
                                <div className="absolute bottom-16 right-4 z-10 w-64">
                                     <SaveToVOD videoUrl={result.url} defaultTitle={`${tool} - Generated Video`} spaces={spaces} />
                                </div>
                             </>
                        ) : (
                             <img src={result.url} className="max-w-full max-h-full object-contain rounded shadow-lg" alt="Result" />
                        )}
                        
                        <div className="absolute top-4 right-4 z-10">
                            <a href={result.url} target="_blank" rel="noreferrer" className="bg-white text-black px-4 py-2 rounded text-xs font-bold hover:bg-gray-200">Download</a>
                        </div>

                        {/* Attribution Watermark */}
                        <div className="absolute bottom-4 right-4 bg-black/50 backdrop-blur px-3 py-1 rounded-full border border-white/10 z-10">
                            <span className="text-[10px] text-white/80 font-medium tracking-wide">
                                Sisnet in collaboration with <span className="text-[#5b13ec] font-bold">BytePlus</span>
                            </span>
                        </div>
                    </>
                ) : (
                    <div className="text-gray-600 text-center">
                        <Icons.GenTools />
                        <p className="mt-2 text-sm">Preview Area</p>
                    </div>
                )}
            </div>
        </div>
    );
};

// --- MODULE: LIBRARY (New) ---
const ModuleLibrary = ({ spaces }) => {
    const [selectedSpace, setSelectedSpace] = useState('');
    const [mediaList, setMediaList] = useState([]);
    const [mainVideo, setMainVideo] = useState(null);
    const [loading, setLoading] = useState(false);

    const refreshMedia = async (space) => {
        setLoading(true);
        try {
            const res = await apiCall(`/api/media?SpaceName=${space}`);
            const list = res.result?.MediaInfoList || [];
            setMediaList(list);
            if (list.length > 0) selectVideo(list[0]);
        } catch(e) { console.error(e); }
        finally { setLoading(false); }
    };

    const selectVideo = async (media) => {
        setMainVideo({ ...media, isLoading: true });
        
        const vid = media.BasicInfo.Vid;
        try {
            const play = await apiCall(`/api/play-info?Vid=${vid}`);
            const sub = await apiCall(`/api/subtitles?Vid=${vid}`);
            
            const playInfoItem = play.result?.PlayInfoList?.[0];
            let url = playInfoItem?.MainPlayUrl || play.result?.OriginalPlayUrl || "";
            const codec = playInfoItem?.Codec;
            const format = playInfoItem?.Format;
            
            const safeSubs = (sub.result || []).map(s => ({
                ...s,
                FinalUrl: s.FinalUrl || s.SubtitleUrl
            }));

            setMainVideo({
                ...media,
                playUrl: url,
                subtitles: safeSubs,
                isLoading: false,
                codec: codec,
                format: format
            });
        } catch (e) {
            console.error("Failed to load video details", e);
            setMainVideo({ ...media, isLoading: false, error: true });
        }
    };

    return (
        <div className="flex flex-col gap-6 h-full">
            {/* Filter Bar */}
            <div className="bg-[#1c1a21] border border-[#2e2839] rounded-2xl p-4 flex gap-4 items-center shadow-lg">
                <div className="w-10 h-10 rounded-full bg-[#2e2839] flex items-center justify-center text-[#5b13ec]">
                    <Icons.Library />
                </div>
                <select 
                    value={selectedSpace} 
                    onChange={(e) => { setSelectedSpace(e.target.value); refreshMedia(e.target.value); }}
                    className="bg-transparent text-white text-lg font-bold outline-none flex-1 cursor-pointer"
                >
                    <option value="">Pilih Space Video...</option>
                    {spaces.map(s => <option key={s.SpaceName} value={s.SpaceName}>{s.SpaceName}</option>)}
                </select>
                <button onClick={()=>refreshMedia(selectedSpace)} disabled={!selectedSpace} className="px-4 py-2 bg-[#2e2839] hover:bg-[#3e3849] rounded-lg text-white text-sm font-bold transition-colors">
                    Refresh
                </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 h-full min-h-0">
                {/* Left: Video List */}
                <div className="lg:col-span-1 bg-[#1c1a21] border border-[#2e2839] rounded-2xl overflow-hidden flex flex-col shadow-xl">
                    <div className="p-4 border-b border-[#2e2839] bg-[#25222d]">
                        <h3 className="text-white font-bold text-sm flex items-center gap-2">
                            <span className="text-[#5b13ec]">📋</span> Daftar Video
                            <span className="text-gray-500 text-xs font-normal ml-auto">{mediaList.length} items</span>
                        </h3>
                    </div>
                    <div className="flex-1 overflow-y-auto p-2 space-y-2 scrollbar-thin scrollbar-thumb-[#2e2839] scrollbar-track-transparent">
                        {mediaList.length === 0 ? (
                            <div className="text-center text-gray-500 py-10 text-sm">
                                {selectedSpace ? "Tidak ada video." : "Pilih space dulu."}
                            </div>
                        ) : (
                            mediaList.map((item) => (
                                <div 
                                    key={item.BasicInfo.Vid} 
                                    onClick={()=>selectVideo(item)} 
                                    className={`p-3 rounded-xl cursor-pointer transition-all border ${
                                        mainVideo?.BasicInfo?.Vid === item.BasicInfo.Vid 
                                        ? 'bg-[#5b13ec]/10 border-[#5b13ec] shadow-md' 
                                        : 'bg-transparent border-transparent hover:bg-[#2e2839] hover:border-[#3e3849]'
                                    }`}
                                >
                                    <div className="flex justify-between items-start mb-1">
                                        <h4 className={`font-bold text-sm line-clamp-1 ${mainVideo?.BasicInfo?.Vid === item.BasicInfo.Vid ? 'text-[#5b13ec]' : 'text-white'}`}>
                                            {item.BasicInfo.Title}
                                        </h4>
                                        <span className="text-[10px] bg-[#0a090c] text-gray-400 px-1.5 py-0.5 rounded border border-[#2e2839]">
                                            {item.SourceInfo?.Duration ? `${Math.floor(item.SourceInfo.Duration)}s` : '0s'}
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center text-xs text-gray-500">
                                        <span className="truncate max-w-[120px]">{item.BasicInfo.Vid}</span>
                                        <span>{item.BasicInfo.CreateTime.split('T')[0]}</span>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {/* Right: Player Area */}
                <div className="lg:col-span-2 flex flex-col gap-6 h-full overflow-y-auto">
                    {mainVideo ? (
                        <>
                            <div className="bg-black rounded-2xl overflow-hidden aspect-video border border-[#2e2839] shadow-2xl relative group flex-shrink-0">
                                {mainVideo.isLoading ? (
                                    <div className="w-full h-full flex items-center justify-center text-gray-500 gap-2">
                                        <div className="w-5 h-5 border-2 border-[#5b13ec] border-t-transparent rounded-full animate-spin"/>
                                        <span className="text-sm">Memuat Player...</span>
                                    </div>
                                ) : mainVideo.playUrl ? (
                                    <NativeVideoPlayer 
                                        src={mainVideo.playUrl} 
                                        poster={null} 
                                        subtitles={mainVideo.subtitles}
                                        codec={mainVideo.codec}
                                        format={mainVideo.format}
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-500 text-sm">
                                        Video tidak dapat diputar.
                                    </div>
                                )}
                            </div>
                            
                            <div className="bg-[#1c1a21] p-6 rounded-2xl border border-[#2e2839] shadow-xl flex-1">
                                <div className="flex justify-between items-start mb-4">
                                    <h2 className="text-2xl font-bold text-white leading-tight">{mainVideo.BasicInfo.Title}</h2>
                                    <span className="px-3 py-1 bg-[#5b13ec]/20 text-[#5b13ec] rounded-full text-xs font-bold border border-[#5b13ec]/30 uppercase">
                                        {mainVideo.BasicInfo.FileType}
                                    </span>
                                </div>
                                
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6 text-xs text-gray-400 bg-[#25222d] p-4 rounded-xl border border-[#2e2839]">
                                    <div>
                                        <span className="block text-gray-500 uppercase tracking-wider text-[10px] mb-1">Created</span>
                                        <span className="text-white font-mono">{mainVideo.BasicInfo.CreateTime.split('T')[0]}</span>
                                    </div>
                                    <div>
                                        <span className="block text-gray-500 uppercase tracking-wider text-[10px] mb-1">Duration</span>
                                        <span className="text-white font-mono">{mainVideo.SourceInfo?.Duration}s</span>
                                    </div>
                                    <div>
                                        <span className="block text-gray-500 uppercase tracking-wider text-[10px] mb-1">Size</span>
                                        <span className="text-white font-mono">{Math.round((mainVideo.SourceInfo?.Size || 0) / 1024 / 1024 * 100) / 100} MB</span>
                                    </div>
                                    <div>
                                        <span className="block text-gray-500 uppercase tracking-wider text-[10px] mb-1">Status</span>
                                        <span className="text-green-400 font-bold">Published</span>
                                    </div>
                                </div>

                                <div>
                                    <h4 className="text-sm font-bold text-gray-300 mb-2 uppercase tracking-wide">Description</h4>
                                    <p className="text-gray-400 text-sm leading-relaxed p-4 bg-[#0a090c] rounded-xl border border-[#2e2839] min-h-[80px]">
                                        {mainVideo.BasicInfo.Description || "Tidak ada deskripsi tersedia untuk video ini."}
                                    </p>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="h-full flex flex-col items-center justify-center bg-[#1c1a21] border border-[#2e2839] rounded-2xl border-dashed text-gray-600">
                            <div className="w-16 h-16 rounded-full bg-[#2e2839] flex items-center justify-center mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM176,88a48,48,0,0,1-96,0,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0Z"/></svg>
                            </div>
                            <span className="text-sm font-medium">Pilih video dari daftar untuk memutar</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// --- MAIN LAYOUT ---
const VOD = () => {
    const [module, setModule] = useState('intel'); 
    const [spaces, setSpaces] = useState([]);
    const [splashFinished, setSplashFinished] = useState(false);

    useEffect(() => {
        apiCall('/api/spaces').then(d => setSpaces(d.result?.List || Array.isArray(d.result) ? d.result : [])).catch(console.error);
    }, []);

    const menu = [
        { id: 'intel', label: 'Audience Intel', icon: <Icons.Intel /> },
        { id: 'creative', label: 'Creative Asst', icon: <Icons.Creative /> },
        { id: 'planner', label: 'Campaign Planner', icon: <Icons.Planner /> },
        { id: 'performance', label: 'Performance', icon: <Icons.Performance /> },
        { id: 'repurpose', label: 'Repurposing', icon: <Icons.Repurpose /> },
        { id: 'gentools', label: 'Gen Tools', icon: <Icons.GenTools /> },
        { id: 'library', label: 'Video Library', icon: <Icons.Library /> },
    ];

    return (
        <div className="flex h-screen bg-[#0a090c] text-white font-sans overflow-hidden">
            {!splashFinished && <SplashScreen onFinish={() => setSplashFinished(true)} />}

            {/* Sidebar */}
            <div className="w-64 bg-[#0a090c] border-r border-[#2e2839] flex flex-col p-4">
                <div className="flex items-center gap-3 px-2 mb-8">
                    <div className="w-8 h-8 bg-gradient-to-br from-[#5b13ec] to-blue-600 rounded-lg flex items-center justify-center font-black text-white">S</div>
                    <div>
                        <h1 className="font-bold tracking-tight">Sinemart<span className="text-[#5b13ec]">.AI</span></h1>
                        <p className="text-[10px] text-gray-500 uppercase tracking-widest">Enterprise Suite</p>
                    </div>
                </div>

                <div className="space-y-1">
                    {menu.map(item => (
                        <button
                            key={item.id}
                            onClick={() => setModule(item.id)}
                            className={`w-full flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium transition-all ${
                                module === item.id 
                                ? 'bg-[#5b13ec]/10 text-[#5b13ec] border border-[#5b13ec]/20' 
                                : 'text-gray-400 hover:text-white hover:bg-[#2e2839]'
                            }`}
                        >
                            {item.icon}
                            {item.label}
                        </button>
                    ))}
                </div>

                <div className="mt-auto pt-6 border-t border-[#2e2839]">
                    <div className="bg-gradient-to-r from-[#1c1a21] to-[#25222d] p-4 rounded-xl border border-[#2e2839]">
                        <p className="text-xs text-gray-400 mb-1">Tokens Balance</p>
                        <p className="text-xl font-bold text-white">∞ <span className="text-xs font-normal text-gray-500">Unlimited</span></p>
                    </div>
                </div>
            </div>

            {/* Main Workspace */}
            <div className="flex-1 flex flex-col">
                <header className="h-16 border-b border-[#2e2839] flex items-center justify-between px-8 bg-[#0a090c]/90 backdrop-blur">
                    <h2 className="text-lg font-bold">{menu.find(m => m.id === module)?.label}</h2>
                    <div className="flex items-center gap-4">
                        <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                        <span className="text-xs text-gray-400 font-mono">SYSTEM: ONLINE</span>
                    </div>
                </header>

                <div className="flex-1 p-8 overflow-y-auto">
                    {module === 'intel' && <ModuleIntel />}
                    {module === 'creative' && <ModuleCreative spaces={spaces} />}
                    {module === 'planner' && <ModulePlanner spaces={spaces} />}
                    {module === 'performance' && <ModulePerformance />}
                    {module === 'repurpose' && <ModuleRepurpose />}
                    {module === 'gentools' && <ModuleGenTools spaces={spaces} />}
                    {module === 'library' && <ModuleLibrary spaces={spaces} />}
                </div>
            </div>
        </div>
    );
};

export default VOD;